import React, { useEffect } from "react";
import PageWithQuery from "./PageWithQuery";
import { withRouter, Redirect } from "react-router-dom";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import RatesPopupHOC from "HOC/RatesPopupHOC";
import { HOUSE_FULL_QUERY_V4 } from "Services/queries";
import { inject, observer } from "mobx-react";
import { useQuery } from "@apollo/client";
import Routes from "Configs/routes";
import { sendMetriks } from "Services/sendMetriks";

const TableComparison = (props) => {
	const {
		ApplicationModel: { siteConfig, searcheModelOneString, searcheModel, currentRegion },
		match: { params },
		new_house_url,
		seoBlock,
	} = props;
	const one_string_search = siteConfig?.settings?.one_string_search?.enabled;
	let house_id = params.house_id
		? +params.house_id
		: one_string_search
			? +searcheModelOneString.house_id
			: searcheModel.house_id;

	useEffect(() => {
		sendMetriks("OPEN_TC");
		if (Routes.RatesInHouse.route === props.match.path) {
			sendMetriks("OPEN_TC_POPULAR");
		}
		if (Routes.DomaNzl.route === props.match.path) {
			sendMetriks("OPEN_TC_NZL");
		}
	}, [house_id]);

	const houseFullQuery = useQuery(HOUSE_FULL_QUERY_V4, {
		skip: !house_id,
		variables: {
			id: parseInt(house_id),
		},
	});

	if (houseFullQuery.loading) {
		return null;
	}

	const houseFull = houseFullQuery?.data?.houseFullV4;

	if (new_house_url && !houseFull?.popular) {
		let location = {
			pathname: generateUrl(Routes.AddressStreet.route, {
				regionUrl: params.regionUrl,
				districtName: params.districtName,
				districtId: params.districtId,
				streetName: params.streetName,
				streetId: params.streetId,
			}),
			state: {
				isRedirect: true,
			},
		};
		return <Redirect to={location} />;
	}

	/**
	 * показ квиза по настройкам из адмики
	 */

	let showQwiz = currentRegion?.hasOwnProperty("is_show_qwiz") ? currentRegion.is_show_qwiz : true;

	return (
		<RatesPopupHOC>
			<PageWithQuery
				withQuiz={showQwiz}
				new_house_url={props.new_house_url}
				house_id={house_id}
				seoBlock={seoBlock}
			/>
		</RatesPopupHOC>
	);
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(observer(TableComparison))));
